// extracted by mini-css-extract-plugin
export default {"container":"StickersPricing_container__JITRd","sticker":"StickersPricing_sticker__PaJYj"};